'use client';
import { jsx, Fragment } from 'react/jsx-runtime';

function NativeScrollArea({ children }) {
  return /* @__PURE__ */ jsx(Fragment, { children });
}

export { NativeScrollArea };
//# sourceMappingURL=NativeScrollArea.mjs.map
